import React, { useEffect, useState } from "react";
import styles from "../../Styles/Signup/styles.module.css";
import "../../Styles/Signup/signup.css";
import bubbles from "../../images/bubble.png";
import bubble from "../../images/Ellipse 13.png";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import hello from "../../images/Vector.svg";
import hii from "../../images/eye.svg";
import "../../Styles/Signin/signin.css";
import { signup, verify, resendOtp } from "../../helper/authApiCalls/auth";
import { Link } from "react-router-dom";
import OTPInput from "otp-input-react";
import { useNavigate } from "react-router-dom";
import { isAuthenticated } from "../../helper/authApiCalls/auth";
import bubbles2 from "../../images/Bubbles (1).svg";
import { useTheme } from "../../Context/ThemeContext";
const Signup = () => {
  const [values, setValues] = useState({
    name: "",
    email: "",
    password: "",
    showpassword: false,
    error: "",
    success: false,
  });

  const [error, setError] = useState("");
  const [error2, setError2] = useState("");
  const [OTP, setOTP] = useState("");
  const [success, setSuccess] = useState(false);
  var { name, email, password } = values;

  const { theme } = useTheme();

  const inputSx = {
    "& .MuiOutlinedInput-input": {
      color: theme === "dark" ? "#ffffff" : "#000000",
      WebkitTextFillColor: theme === "dark" ? "#ffffff" : "#000000",
    },

    "& .MuiOutlinedInput-input:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 1000px var(--bg-secondary) inset !important",
      WebkitTextFillColor: theme === "dark" ? "#ffffff" : "#000000",
    },

    "& .MuiInputLabel-root": {
      color: theme === "dark" ? "#cbd5e1" : "#4b5563",
    },
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setSuccess(false);
    setValues({ ...values, error: false });
    email = email.toLocaleLowerCase();

    signup({ name, email, password }).then((data) => {
      console.log("frn signup ,", data);
      if (data.status === "fail") {
        console.log("yes its error");
        setError(data.message);
        setSuccess(false);
      } else {
        setSuccess(true);
      }
    });
  };

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showpassword: !values.showpassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  let navigate = useNavigate();
  const onOtpSubmit = (e) => {
    e.preventDefault();
    email = email.toLocaleLowerCase();

    const sendBody = {
      email: email,
      otp: OTP,
    };
    verify(sendBody).then((data) => {
      console.log(data, "ver");
      if (data.status === "fail") {
        setError(data.message);
      } else {
        return navigate("/signin");
      }
    });
  };

  function sendOtp(e) {
    setSuccess(true);
    e.preventDefault();

    const sendBody = {
      email: values.email.toLocaleLowerCase(),
    };
    resendOtp(sendBody).then((data) => {
      if (data.status === "fail") {
        setError2(data.message);
      }
    });
  }

  useEffect(() => {
    if (isAuthenticated()) {
      return navigate("/");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const otpDesk = () => {
    return (
      <div>
        <div className={styles.mainlog}>
          <span>Sign In Using OTP</span>
        </div>
        <div className={styles.someshit}>
          <span>
            Enter the 6-digit OTP sent on your registered email address
          </span>
        </div>
        <div className={styles.in}>
          <div className={styles.someshit2}>
            <OTPInput
              value={OTP}
              onChange={setOTP}
              autoFocus
              className="heyHEllo"
              OTPLength={6}
              otpType="number"
              disabled={false}
            />
          </div>
        </div>
        {error2 && <div className={styles.error}>*{error2}</div>}
        <div className={styles.resend}>
          <button onClick={sendOtp}>Resend OTP</button>
        </div>
        <div className={styles.button}>
          <button onClick={onOtpSubmit}>Sign In</button>
        </div>
      </div>
    );
  };

  const signupDesktop = () => {
    return (
      <div className="text">
        <div className={styles.signup}>
          <div className={styles.rightflank}>
            <div className={styles.fig}>
              <img src={bubbles} alt="%" />
            </div>
            <div className={styles.fig2}>
              <img src={bubble} alt="%" />
            </div>

            <div className={styles.name}>
              <div className={styles.uppername}>
                <span>EduUdr</span>
              </div>
              <div className={styles.lowername}>
                <span>upgrading the community</span>
              </div>
            </div>
            <div className={styles.downspans}>
              <div className={styles.upspan}>
                <span>Grow by learning</span>
                <img src={bubble} alt="" />
              </div>
              <div className={styles.downspan}>
                <span>
                  We strive to help and bring together the online learners
                  community by compiling knowledgeable resources from all over
                  the internet.
                </span>
              </div>
            </div>
          </div>
          <div className={styles.leftflank}>
            {!success ? (
              <div className={styles.leftmain}>
                <div className={styles.mainlog}>
                  <span>Sign up</span>
                </div>
                <div className={styles.in}>
                  <div className={styles.in1}>
                    <TextField
                      label="Full Name"
                      type="text"
                      id="outlined-size-small"
                      size="small"
                      value={name}
                      onChange={handleChange("name")}
                      sx={inputSx}
                    />
                  </div>
                  <div className={styles.in3}>
                    <TextField
                      label="Email"
                      type="email"
                      id="outlined-size-small"
                      size="small"
                      value={email}
                      onChange={handleChange("email")}
                      sx={inputSx}
                    />
                  </div>
                  <div className={styles.in2}>
                    <TextField
                      label="Password"
                      type={values.showpassword ? "text" : "password"}
                      value={values.password}
                      onChange={handleChange("password")}
                      id="outlined-size-small"
                      size="small"
                      sx={inputSx}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {values.showpassword && (
                                <img src={hii} alt="*" className="img" />
                              )}
                              {!values.showpassword && (
                                <img src={hello} alt="*" />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                  <div className={styles.min}>
                    <span>Between 8 to 20 characters</span>
                  </div>
                  {error && <div className={styles.error}>*{error}</div>}
                  <div className={styles.button}>
                    <button onClick={onSubmit}>Sign Up</button>
                  </div>
                  <div className={styles.info}>
                    <div className={styles.info1}>
                      <span>Already have an account? </span>
                      <a href="/signin">Log in</a>
                    </div>
                    <div className={styles.info2}>
                      <span>Are you a creator?</span>
                    </div>
                    <div className={styles.button2}>
                      <Link to="/creatorform">
                        <button>Join As Creator</button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div>{otpDesk()}</div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const signupMobile = () => {
    return (
      <div className="text2">
        <div className={styles.signinMob}>
          <div className={styles.bubblecontain}>
            <img src={bubbles2} alt="%" />
          </div>

          <div className={styles.name}>
            <div className={styles.uppername}>
              <span>EduUdr</span>
            </div>
            <div className={styles.lowername}>
              <span>upgrading the community</span>
            </div>
          </div>
          <div className={styles.body}>
            {!success ? (
              <div className={styles.innerdivm}>
                <div className={styles.loginm}>
                  <span>Sign Up</span>
                </div>
                <div className={styles.in}>
                  <div className={styles.in1}>
                    <TextField
                      label="Full Name"
                      type="text"
                      id="outlined-size-small"
                      size="small"
                      value={name}
                      onChange={handleChange("name")}
                      sx={inputSx}
                    />
                  </div>
                  <div className={styles.in3}>
                    <TextField
                      label="Email"
                      type="email"
                      id="outlined-size-small"
                      size="small"
                      value={email}
                      onChange={handleChange("email")}
                      sx={inputSx}
                    />
                  </div>
                  <div className={styles.in2}>
                    <TextField
                      label="Password"
                      type={values.showpassword ? "text" : "password"}
                      value={values.password}
                      onChange={handleChange("password")}
                      id="outlined-size-small"
                      size="small"
                      sx={inputSx}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {values.showpassword && (
                                <img src={hii} alt="*" className="img" />
                              )}
                              {!values.showpassword && (
                                <img src={hello} alt="*" />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                  <div className={styles.min}>
                    <span>Between 8 to 20 characters</span>
                  </div>
                  {error && <div className={styles.error}>*{error}</div>}
                  <div className={styles.button}>
                    <button onClick={onSubmit}>Sign Up</button>
                  </div>
                  <div className={styles.info}>
                    <div className={styles.info1}>
                      <span>Already have an account? </span>
                      <a href="/signin">Log in</a>
                    </div>
                    <div className={styles.info2}>
                      <span>Are you a creator?</span>
                    </div>
                    <div className={styles.button2}>
                      <Link to="/creatorform">
                        <button>Join As Creator</button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className={styles.innerdivm}>{otpDesk()}</div>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      {signupDesktop()}
      {signupMobile()}
    </div>
  );
};

export default Signup;
